export const LANDING_PAGE = "/"
export const ABOUT = "/a-abace"
export const NEWS = "/noticias"
export const EVENTS = "/eventos"
export const GALLERY = "/galeria"
export const GALLERYITEMS = "/itens-galeria"
export const ACTIVITIES = "/atividades"
export const RELATIONSHIP = "/lacos"
